/*
 * Copyright '2025' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { BaseNotificationsProvider } from "sirius-platform-support-library/shared/notifications/providers/base-notifications.provider";
import { NotificationsService } from "../services/notifications.service";
import { IAuthenticationService } from "sirius-platform-support-library/shared/authentication/authentication-service.interface";

export const NotificationsProviderTypeName = "NotificationsProvider";

export class NotificationsProvider extends BaseNotificationsProvider {
  public static readonly NAMESPACE = "tdp";

  private readonly notificationsService: NotificationsService;
  private authenticationService: IAuthenticationService;

  public constructor(
    serviceNotificationsService: NotificationsService,
    authenticationService: IAuthenticationService
  ) {
    super(NotificationsProvider.NAMESPACE);
    this.notificationsService = serviceNotificationsService;
    this.authenticationService = authenticationService;
  }

  public async getNotificationsCount(): Promise<number> {
    return this.authenticationService.isUserAuthenticated()
      ? ((await this.notificationsService.getNotificationsCount()) as any)
          ?.notificationsCount || 0
      : 0;
  }
}
